import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import TimelinePointItem from './TimelinePointItem'
import { getPayoutMatchingHistory } from '../core/api'
import { TimelinePoint } from '../core/response.types'
import { MUTED } from '../core/consts'

/**
 * История выплаты в мэтчинге: вход, предложения сумм, матчи депозитов и их судьба, споры, паузы,
 * алерты, остановка и итог. Тексты точек собирает бэкенд; здесь только отрисовка и ссылки.
 *
 * reloadKey — тот же ключ, что перезагружает карточку после действия: пауза или замена реквизита
 * должны появиться в истории сразу.
 */
const PayoutMatchingHistory: React.FC<{ token: string; reloadKey: number }> = ({
  token,
  reloadKey,
}) => {
  const [points, setPoints] = useState<TimelinePoint[] | null>(null)
  const [error, setError] = useState(false)

  // Another payout's points must not stay on screen; a reload of the same one may keep them.
  useEffect(() => {
    setPoints(null)
  }, [token])

  useEffect(() => {
    let cancelled = false
    setError(false)

    getPayoutMatchingHistory(token)
      .then(({ data }) => {
        if (cancelled) return
        // ApiResponse is a union on `success`: `data.data` exists only on the success branch.
        if (!data.success) {
          setError(true)

          return
        }
        setPoints(data.data.points ?? [])
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })

    return () => {
      cancelled = true
    }
  }, [token, reloadKey])

  if (error) {
    return (
      <div style={{ padding: '18px 28px', fontSize: 13, color: MUTED }}>
        Не удалось загрузить историю
      </div>
    )
  }

  if (points === null) {
    return (
      <div className='d-flex justify-content-center' style={{ padding: 24 }}>
        <Spinner animation='border' variant='primary' size='sm' />
      </div>
    )
  }

  if (points.length === 0) {
    return <div style={{ padding: '18px 28px', fontSize: 13, color: MUTED }}>Событий нет</div>
  }

  return (
    <div style={{ padding: '18px 28px' }}>
      {points.map((point, index) => (
        <TimelinePointItem
          key={`${point.at}-${point.kind}-${index}`}
          point={point}
          last={index === points.length - 1}
          withDate
        />
      ))}
    </div>
  )
}

export default PayoutMatchingHistory
